import React from "react";
import { Grid } from "@mui/material";
import CartoonModel from "./CartoonModel";

const CartoonPage = () => {
  return(
    <Grid>
      <CartoonModel />
    </Grid>
  )
}
export default CartoonPage;